@import (reference) '../../style.module.less';

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.multi-select-dropdown-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.dropdown-toggler {
  @input-text();
  @input-states();
  background: transparent;
  &:hover {
    box-shadow: none;
  }
}
